import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import cartReducer from './slices/cartSlice';
import authReducer from './slices/authSlice'; // Import the auth slice
import productReducer from './slices/productSlice';
// Persist configuration for the cart slice
const cartPersistConfig = {
  key: 'cart',
  storage,
};

// Create a persisted reducer for the cart slice
const persistedCartReducer = persistReducer(cartPersistConfig, cartReducer);

// Combine reducers for cart and auth
const rootReducer = combineReducers({
  cart: cartReducer,
  auth: authReducer, // Auth slice is not persisted
  products: productReducer,
});

// Configure the store
const store = configureStore({
  reducer: rootReducer,
});

// export const persistor = persistStore(store);
export default store;
